var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var curry = require('ramda/src/curry');
var evaluator = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(func, iterator) {
    var next;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            next = iterator.next();
            if (!next.done) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            _context.next = 5;
            return func(next.value);
          case 5:
            return _context.abrupt("return", evaluator(func, iterator));
          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function evaluator(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * A promise for each helper (serial). Given an asynchronous function
 * and an iterable or an object, this will evaluate the function against
 * each value of the iterable, serially.
 *
 * @func
 * @memberof module:omnibelt
 * @name forEachSerialP

 * @param {Function} func - An async function
 * @param {Iterable} iterable - Object or iterable
 * @return {Promise} A promise that will resolve to undefined when iteration is done
 * @summary Function -> Iterable -> Promise<iterable>
 */
var forEachSerialP = curry( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(func, iterable) {
    var iterator;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (iterable) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", iterable);
          case 2:
            iterator = iterable[Symbol.iterator] ? iterable[Symbol.iterator]() : Object.entries(iterable)[Symbol.iterator]();
            _context2.next = 5;
            return evaluator(func, iterator);
          case 5:
            return _context2.abrupt("return", iterable);
          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function (_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}());
module.exports = forEachSerialP;